import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-sales-order-add-note-dialog',
  templateUrl: './sales-order-add-note-dialog.component.html',
  styleUrls: ['./sales-order-add-note-dialog.component.scss']
})
export class SalesOrderAddNoteDialogComponent implements OnInit {
  form: FormGroup;
  config!: any;

  constructor(
    public dialogRef: MatDialogRef<SalesOrderAddNoteDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    public dialog: MatDialog
  ) {
    this.form = fb.group({
      salesOrderHeaderId: [null],
      salesOrderNumber: [null],
      salesOrderNoteText: [null, Validators.compose([Validators.required, Validators.maxLength(200)])],
      salesOrderNoteActive: [true],
      addToDoList: [false],
      toDoListItemTypeId: [null]
    });

    this.form.patchValue(data);
   }

  ngOnInit() {
    this.baseService
      .executeCommand<any>('portal_sales_order_note_modify_config', {
        toDoListItemId: this.data.toDoListItemId,
      })
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.config = response.data;
        }
      });
  }

  save() {
    this.baseService.executeCommand('portal_sales_order_note_modify', this.form.value)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        }
      });
  }

  addToDoListChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.form.controls['toDoListItemTypeId'].setValidators(Validators.compose([Validators.required]));
    } else {
      this.form.controls['toDoListItemTypeId'].clearValidators();
      this.form.controls['toDoListItemTypeId'].setValue(null);
    }
    this.form.controls['toDoListItemTypeId'].updateValueAndValidity();
    this.form.updateValueAndValidity();

  }

}
